// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import noop from 'lodash/noop'
import omit from 'lodash/omit'
import { inject } from 'mobx-react'
import React from 'react'
import { Mutation } from 'react-apollo'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import EditButton from '../../../common/iconButtons/EditButton'
import type { AuthStore } from '../auth/types'
import css from './Users.css'
import type { User } from './userTypes'
import { deleteUser } from './usersQueries'

type Props = {
  data: User
  authStore: AuthStore
  onEdit: (...props: any) => any
  onDelete: (...props: any) => any
  refetch: (...props: any) => any
  confirmModal: {
    show: (...props: any) => any
  }
}

@inject('authStore')
class UserRow extends React.Component<Props> {
  render() {
    const { data, onEdit, onDelete, refetch, authStore } = this.props
    const userId = authStore.getUserId()

    return (
      <TableRow>
        <TableCell>{data.name}</TableCell>
        <TableCell className={css.tableCellActions}>
          <EditButton onClick={() => (data.id ? onEdit(omit(data, ['__typename'])) : noop)} aria-label='edit-user' />
          <Mutation mutation={deleteUser}>
            {(onMutate) => <DeleteButton onClick={() => onDelete(onMutate, refetch, data.id, userId)} />}
          </Mutation>
        </TableCell>
      </TableRow>
    )
  }
}

export default UserRow
